import { forwardRef } from "react";

import "./DropdownButton.css";

const DropdownButton = forwardRef((props, ref) => {
  const { children, toggle, open, active } = props;

  return (
    <button
      type="button"
      onClick={toggle}
      className={`dropdown-btn ${open ? "button-open" : ""} ${active ? "button-active" : ""}`}
      aria-haspopup="true"
      aria-expanded={open}
      ref={ref}
    >
      {children}
      <span className="toggle-icon" aria-hidden="true">
        <span className="material-symbols-outlined">{open ? "arrow_drop_up" : "arrow_drop_down"}</span>
      </span>
    </button>
  );
});

export default DropdownButton;
